import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const FilterWrapperMain = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 390px;
    height: ${({bannerHeight}) =>
        bannerHeight ? `calc(78vh - ${bannerHeight})` : '78vh'};
    align-self: center;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    overflow: hidden;
    z-index: 3000;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
		width: 100vw !important;
		max-width: none !important;
        padding-bottom:80px;
    `}
    @media screen and (orientation: landscape) and (max-width: 1366px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
		width: 100vw !important;
		max-width: none !important;
    }
`;

export const FilterContentMain = styled.div`
    ${scrollBarStyle}
    display: flex;
    flex-direction: column;
    background: #f5f5f5 !important;
    flex-grow: 1;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
`;

export const FilterHeading = styled.p`
    color: ${({ color }) => (color ? color : '#140f4b')};
    display: ${({ display }) => (display ? display : 'inline-block')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '22px')};
    line-height: 39px;
    opacity: 1;
    font-family: ${({ isRegular }) =>
        isRegular ? 'AvenirNextWorld Regular' : 'AvenirNextWorld Demi'};
    margin: 0;
    letter-spacing: 0;
    margin-right: 20px;
    border-bottom: ${({ selected }) =>
        selected ? '4px solid #1010EB' : 'none'};
    &:hover {
        cursor: pointer;
    }
    ${media.mobileDevice`
        font-size: 18px;
        line-height: 31px;
        color: #000000;
        margin-right: 27px;
    `}
`;

export const Reset = styled.p`
    color: ${({ isView }) => (isView ? '#1010eb' : '#A8A8A8')};
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    margin: 0;

    line-height: 27px;
    align-self: center;
    &:hover {
        cursor: pointer;
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 16px;
    margin-top: 11px;
    margin-right: 16px;
    margin-bottom: 7px;
    ${media.mobileDevice`
    margin-bottom: 25px;
`}
`;
export const FilterFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding-right: 14px;
    padding-left: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: #ffff;
    position: static;
    bottom: 0px;
    box-sizing: border-box;
    width: 100%;
    height: 10%;
`;

export const FooterCloseButton = styled.button`
    height: 38px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    border: 1px solid #1010eb;
    background: #ffff;
    align-content: center;
    width: 40%;
    &:hover {
        cursor: pointer;
    }
`;

export const FooterApplyButton = styled.button`
    height: 38px;
    background: ${(props) => (props.applyButton ? '#1010EB' : '#3c3c3c')};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    width: 40%;
    opacity: 1;
    border: none;
    &:hover {
        cursor: pointer;
    }
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: ${(props) => props.color};
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const FilterBlock = styled.div`
    top: 5rem;
    right: 2rem;
    ${media.smalDevice`
		top: 0;
		left: 0;
		margin-top:0;
        right:0;
	`}
    z-index: 200;
    background: #f5f5f5;
    opacity: 1;
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
    }
`;

export const FooterWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-evenly;
`;
export const EmptyBox = styled.div`
    margin-top: 0.8rem;
    margin-bottom: 3.6rem;
 ${media.mobileDevice`
        margin-bottom: 240px;
    `}
    @media only screen and (min-device-width: 370px) and (max-device-width: 950px) and (orientation : landscape) {
        margin-bottom: 3.6rem;
    }
`;

export const FilterHeaderContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;
